import { render, staticRenderFns } from "./dbPermissionOrder.vue?vue&type=template&id=3ee676e4&scoped=true&"
import script from "./dbPermissionOrder.vue?vue&type=script&lang=js&"
export * from "./dbPermissionOrder.vue?vue&type=script&lang=js&"
import style0 from "./dbPermissionOrder.vue?vue&type=style&index=0&id=3ee676e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee676e4",
  null
  
)

export default component.exports